import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import { format } from "date-fns";

import { Badge } from "@lifepay/rc-ui-toolkit";

// import CardSmsControl from "../controls/CardSmsControl";

// import cardtype from "./cardtype";

import {
  QUANTITY_LIMIT_TYPES,
  CURRENCY_LIMIT_TYPES,
  LIMIT_PERIOD_TYPES,
  SHOW_DATES,
} from "./CONSTANTS";
import styles from "./CardLimitBadge.m.scss";

function daysHR(days) {
  const lastDigit = days
    .toString()
    .split("")
    .pop();
  switch (lastDigit) {
    case "1":
      return "день";
    case "2":
      return "дня";
    case "3":
      return "дня";
    case "4":
      return "дня";
    case "5":
      return "дней";
    case "6":
      return "дней";
    case "7":
      return "дней";
    case "8":
      return "дней";
    case "9":
      return "дней";
    case "0":
      return "дней";
    default:
      return "день";
  }
}

function CardLimitBadge(props) {
  const {
    theme,
    amountSpent,
    amountLeft,
    amountThreshold,
    limitType,
    limitPeriodType,
    isIndividual,
    // quantityLimitTypes,
    currencyLimitTypes,
    limitPeriodTypes,
    showDates,
    dateFrom,
    dateTo,
    totalDays,
  } = props;

  // const quantityLimitType = limitType
  //   ? quantityLimitTypes[limitType] || limitType
  //   : "limitType: -";
  const currencyLimitType = limitType
    ? currencyLimitTypes[limitType] || limitType
    : "limitType: -";
  const verboseLimitPeriodType = limitPeriodType
    ? limitPeriodTypes[limitPeriodType] || limitPeriodType
    : "limitPeriodType: -";
  const verboseIsIndividual = isIndividual
    ? "по одной карте"
    : "по диапазону карт";

  let dateBadgeText;
  if (dateFrom && dateTo) {
    dateBadgeText = `c ${dateFrom ? format(dateFrom, "DD.MM.YYYY") : "-"} по ${
      dateTo ? format(dateTo, "DD.MM.YYYY") : "-"
    }`;
  } else if (totalDays !== undefined) {
    dateBadgeText = `на ${totalDays} ${daysHR(totalDays)}`;
  }

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.header)}>
        {/* <Badge>{quantityLimitType}</Badge>
        {currencyLimitTypes[limitType] ? (
          <Badge>{currencyLimitType}</Badge>
        ) : null} */}
        <Badge>{verboseLimitPeriodType}</Badge>
        {showDates[limitPeriodType] && dateBadgeText ? (
          <Badge>{dateBadgeText}</Badge>
        ) : null}
        <Badge>{verboseIsIndividual}</Badge>
      </div>
      <div className={classnames(theme.body)}>
        <span className={classnames(theme.value)}>{`${amountLeft}`}</span>
        <span className={classnames(theme.divider)}>{` / `}</span>
        <span className={classnames(theme.value)}>{` ${amountThreshold}`}</span>
        <span className={classnames(theme.divider)}>{` ( `}</span>
        <span className={classnames(theme.value)}>{` ${amountSpent}`}</span>
        <span className={classnames(theme.divider)}>{` ) `}</span>
        <span
          className={classnames(theme.label)}
        >{`${currencyLimitType}`}</span>
      </div>
    </div>
  );
}

CardLimitBadge.displayName = "CardLimitBadge";

CardLimitBadge.propTypes = {
  theme: PropTypes.object,
  amountSpent: PropTypes.string,
  amountLeft: PropTypes.string,
  amountThreshold: PropTypes.string,
  limitType: PropTypes.string,
  limitPeriodType: PropTypes.string,
  isIndividual: PropTypes.bool,
  quantityLimitTypes: PropTypes.object,
  currencyLimitTypes: PropTypes.object,
  limitPeriodTypes: PropTypes.object,
  showDates: PropTypes.object,
  dateFrom: PropTypes.instanceOf(Date),
  dateTo: PropTypes.instanceOf(Date),
  totalDays: PropTypes.number,
};

CardLimitBadge.defaultProps = {
  quantityLimitTypes: QUANTITY_LIMIT_TYPES,
  currencyLimitTypes: CURRENCY_LIMIT_TYPES,
  limitPeriodTypes: LIMIT_PERIOD_TYPES,
  showDates: SHOW_DATES,
};

export default themr("@lifepay/CardLimitBadge", styles)(CardLimitBadge);



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/CardLimitBadge/CardLimitBadge.js